/* GSAP loader: expects window.initPageAnimations to be defined. */
(function () {
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function shouldAnimate() {
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return false;
    }
    return Boolean(
      document.querySelector(
        ".fade-group, .fade-in, .pinned-content, .retailer-banner, .drinks-product-main, .review-cards"
      )
    );
  }

  function boot() {
    if (!shouldAnimate()) {
      return;
    }

    if (!window.gsapAssetUrls) {
      console.warn("GSAP asset URLs missing.");
      return;
    }

    loadScript(window.gsapAssetUrls.gsap)
      .then(function () {
        return loadScript(window.gsapAssetUrls.scrollTrigger);
      })
      .then(function () {
        return loadScript(window.gsapAssetUrls.scrollSmoother);
      })
      .then(function () {
        if (typeof window.initPageAnimations === "function") {
          window.initPageAnimations();
        }
        window.__gsapReady = true;
        window.dispatchEvent(new Event("gsap:ready"));
      })
      .catch(function () {
        console.warn("GSAP assets failed to load.");
      });
  }

  function applyEditorFallback(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll(".retailer-banner .retailer-banner__logo").forEach(function (logo) {
      logo.style.opacity = "1";
      logo.style.transform = "none";
    });

    scope.querySelectorAll(".pinned-content [data-section-id]").forEach(function (section) {
      var mediaObjects = section.querySelectorAll(".pinned-content__media-object");
      if (!mediaObjects.length) {
        return;
      }

      mediaObjects.forEach(function (media, index) {
        media.style.opacity = index === 0 ? "1" : "";
        media.style.transform = "none";
      });
    });
  }

  var inEditor = window.Shopify && Shopify.designMode;
  if (inEditor) {
    function bootEditorFallback() {
      applyEditorFallback(document);
    }

    document.addEventListener("shopify:section:load", function (event) {
      applyEditorFallback(event && event.target ? event.target : document);
    });

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bootEditorFallback);
    } else {
      bootEditorFallback();
    }
    return;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
